var Account, AccountState, ActionFactories, Breadcrumbs, ExportGalleryPage, GridView, HeadingBar, Page, m;

m = require('mithril');

ActionFactories = require('../../state/ActionFactories');

AccountState = require('../../state/Account');

Account = require('../components/Account');

Page = require('../components/Page');

HeadingBar = require('../components/HeadingBar');

Breadcrumbs = require('../components/Breadcrumbs');

GridView = require('../components/GridView');

ExportGalleryPage = {
  view: function(ctrl, args) {
    var account, editGallery, gallery, library, p;
    account = args.account();
    library = args.library();
    editGallery = args.editGallery();
    gallery = {
      id: editGallery.id,
      name: editGallery.name,
      photos: (function() {
        var i, len, ref, results;
        ref = library.photos;
        results = [];
        for (i = 0, len = ref.length; i < len; i++) {
          p = ref[i];
          if (editGallery.photoIds.indexOf(p.name) !== -1) {
            results.push(p);
          }
        }
        return results;
      })()
    };
    return m(Page, {
      account: account,
      content: [
        m(HeadingBar, {
          content: m(Breadcrumbs, {
            items: [
              {
                icon: 'home',
                title: 'Home',
                onclick: function() {
                  return m.route('/home');
                }
              }, {
                icon: 'warning',
                content: 'Admin',
                onclick: function() {
                  return m.route('/admin');
                }
              }, {
                content: 'Export Gallery'
              }
            ]
          })
        }), m('h1', 'Export Gallery'), m('textarea[style="width:100%;min-height:400px;"]', {
          value: JSON.stringify(gallery)
        })
      ]
    });
  }
};

module.exports = function(store) {
  return m(ExportGalleryPage, {
    account: function() {
      return store.getState().account;
    },
    library: function() {
      return store.getState().library;
    },
    editGallery: function() {
      return store.getState().editGallery;
    }
  });
};

//# sourceMappingURL=data:application/json;base64,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
